import { apiClient } from "./ApiClient";

const WalletService = {
  async getUserWallet() {
    try {
      const response = await apiClient.get("/wallet/carrier");
      const response_data_filtered = response.data.filter(
        (wallet) => wallet.payout_allowed === false,
      );
      return response_data_filtered[0] || null;
    } catch (error) {
      const err = new Error("Failed to fetch wallet");
      err.status = error.response?.status;
      err.response = {
        status: error.response?.status,
        data: error.response?.data,
      };
      throw err;
    }
  },

  async changeWalletCurrency(walletId, newCurrency) {
    try {
      const response = await apiClient.put(`/wallet/${walletId}/currency`, {
        new_currency: newCurrency,
      });
      return response.data;
    } catch (error) {
      const err = new Error(
        error.response?.data?.detail || "Failed to change wallet currency",
      );
      err.status = error.response?.status;
      err.response = {
        status: error.response?.status,
        data: error.response?.data,
      };
      throw err;
    }
  },

  async getTransactions({
    walletId,
    currency,
    skip = 0,
    limit = 10,
    sort_by = "date",
    sort_order = "desc",
    filters = {},
  }) {
    const params = new URLSearchParams({
      sort_by,
      sort_order,
      skip: String(skip),
      limit: String(limit),
    });

    if (walletId) params.append("wallet_id", walletId);
    if (currency) params.append("currency", currency);
    if (filters.min_amount)
      params.append("min_amount", String(filters.min_amount));
    if (filters.max_amount)
      params.append("max_amount", String(filters.max_amount));
    if (filters.currency) params.append("currency", filters.currency);
    if (filters.type) params.append("type", filters.type);

    try {
      const response = await apiClient.get(`/transaction/batch?${params}`);
      return response.data;
    } catch (error) {
      const err = new Error("Failed to fetch transactions");
      err.status = error.response?.status;
      err.response = {
        status: error.response?.status,
        data: error.response?.data,
      };
      throw err;
    }
  },

  async getWalletStats(walletId) {
    try {
      const response = await apiClient.get(`/wallet/${walletId}/stats`);
      return response.data;
    } catch (error) {
      const err = new Error("Failed to fetch wallet stats");
      err.status = error.response?.status;
      err.response = {
        status: error.response?.status,
        data: error.response?.data,
      };
      throw err;
    }
  },

  async transfer(payload) {
    try {
      return (await apiClient.post("/wallet/transfer", payload)).data;
    } catch (error) {
      throw error;
    }
  },

  async transferUser(payload) {
    try {
      console.log("🔄 TransferUser payload:", payload);
      const response = await apiClient.post("/wallet/transfer/user", payload);
      return response.data;
    } catch (error) {
      const err = new Error(
        error.response?.data?.detail || "Failed to transfer funds",
      );
      err.status = error.response?.status;
      err.response = {
        status: error.response?.status,
        data: error.response?.data,
      };
      throw err;
    }
  },

  async topUp(payload) {
    try {
      return (await apiClient.post("/wallet/top-up", payload)).data;
    } catch (error) {
      throw error;
    }
  },

  async updateWallet({ id, balance, currency, user_id, carrier_id }) {
    try {
      const payload = {
        id,
        balance,
        currency,
        user_id,
        carrier_id,
      };
      console.log("UPDATE WALLET PAYLOAD >>>", payload);
      const response = await apiClient.put("/wallet/", payload);
      return response.data;
    } catch (error) {
      const err = new Error(
        error.response?.data?.detail || "Failed to update wallet",
      );
      err.status = error.response?.status;
      err.response = {
        status: error.response?.status,
        data: error.response?.data,
      };
      throw err;
    }
  },

  async deleteWallet(id) {
    try {
      const response = await apiClient.delete(`/wallet/${id}`);
      return response.data;
    } catch (error) {
      const err = new Error(
        error.response?.data?.detail || "Failed to delete wallet",
      );
      err.status = error.response?.status;
      err.response = {
        status: error.response?.status,
        data: error.response?.data,
      };
      throw err;
    }
  },

  async fetchWalletsAdmin({ skip, limit, sort_by, sort_order, filters }) {
    const params = new URLSearchParams({
      skip: skip.toString(),
      limit: limit.toString(),
      sort_by,
      sort_order,
    });

    for (const key in filters) {
      if (filters[key] !== null && filters[key] !== "") {
        params.append(key, filters[key]);
      }
    }

    try {
      const response = await apiClient.get(`/wallet/batch?${params}`);
      return response.data;
    } catch (error) {
      const err = new Error(
        error.response?.data?.detail || "Failed to fetch wallets",
      );
      err.status = error.response?.status;
      err.response = {
        status: error.response?.status,
        data: error.response?.data,
      };
      throw err;
    }
  },
};

export default WalletService;
